/**
 * EVENT REGISTRATION FORM
 * @todo: Ideally I'd like to nove this into the "event" directory
 */

(function( $ ) {
		$( document ).ready( function() {
			'use strict';

			let eventRegistrationForm = $( '#event-registration-form' ),
			    registrantEmail       = $( '#registrant_email' ),
			    eventImisCode         = $( '#event_imis_code' ),
			    someoneElseRadio      = $( '#someone_else' ),
			    referralFormSection   = $('#referral-section');

			//only run on event registration form
			if ( eventRegistrationForm.length > 0 ) {
				// Display alert to ISDA staff if event not in imis
				checkEventInImis();

				$( '.btn-event-registration-back' )
					.click( previousCollapsibleBtn );
				$( '.btn-event-registration-next' )
					.click( nextCollapsibleAppBtn );
				eventRegistrationForm.validator()
				                     .on( 'submit', revealSectionErrors );

				if ( someoneElseRadio.is( ':checked' ) ) {
					clearContactDetails();
					referralFormSection.addClass('hidden');
				}

				// send imis code and registrant email to endpoint to check if they are already registered
				registrantEmail.on( 'blur', function() {
					if ( someoneElseRadio.is( ':checked' ) ) {
						checkRegistrantEmail( registrantEmail.val(), eventImisCode.val(), 'someone_else' );
					} else {
						checkRegistrantEmail( registrantEmail.val(), eventImisCode.val(), 'myself' );
					}
				} );

				//@todo: Should validate read only fields if empty
				$( '.btn-submit-conf-reg' ).on( 'click', function( e ) {
					if ( $( this ).hasClass( 'prevent-submit' ) ) {
						e.preventDefault();
					}

					if ( someoneElseRadio.is( ':checked' ) ) {
						checkRegistrantEmail( registrantEmail.val(), eventImisCode.val(), 'someone_else' );
					} else {
						checkRegistrantEmail( registrantEmail.val(), eventImisCode.val(), 'myself' );
					}
				} );

				saveInitialDetails();
				setReadonlyFields();
				conditionalRequireCard();

				$( '#registration-card-details' ).hide()
				                                 .find( '.form-control.ccard' )
				                                 .removeAttr( 'required', 'required' );

				$( '#payment-type' ).change( function( e ) {
					conditionalRequireCard();
					$( '.paymentMethods' ).addClass( 'hidden' );
					$( '.paymentMethods.' + e.target.value )
						.removeClass( 'hidden' );
				} );

				$( '.onBehalf' ).change( function( e ) {
					if ( $( this ).val() === 'someone_else' ) {
						clearContactDetails();
						referralFormSection.addClass( 'hidden' );
					} else {
						if ( referralFormSection.hasClass( 'hidden' ) ) {
							referralFormSection.removeClass('hidden');
						}
					}
					//only restores when switching to "myself"
					restoreContactDetails();
					setReadonlyFields();
					toggleRequiredOnVerifyEmail( e.currentTarget );
				} );

				$( '#event-registration-form' ).validator()
				                               .on( 'submit', function( e ) {
					                               if ( !e.isDefaultPrevented() ) {
						                               $( '[type=submit]', this )
							                               .attr( 'disabled', 'disabled' )
							                               .addClass( 'disabled' );
						                               $( '[type=submit]', this )
							                               .html( ' <img class="spinner" src="' + ISDA_Main.ajaxLoader + '">' );
					                               }

				                               } );

				$( '#agm-fees input:radio' ).focus( function() {
					let feeRadio = $( this );
					//accompanying person field for AGM
					agmPlusFeeConditional( feeRadio );
					//toggle price display on AGM
					agmPaymentMethodPrice( feeRadio );
				} );

				$( document )
					.on( 'change', '#event-billing-checkbox', function() {
						toggleRequiredOnVerifyBillingEmail( $( this ) );

						let confirmEmailSection = $( '#event-billing-email' );
						if ( $( this ).is( ':checked' ) ) {
							confirmEmailSection.removeClass( 'hidden' );
						} else {
							confirmEmailSection.addClass( 'hidden' );
							//put back registrant's address in billing
							$( '#event-billing-address .form-control' )
								.each( function( i, elem ) {
									let previousValue = $( elem )
										.data( 'previousValue' );
									$( elem ).val( previousValue );
								} );

							//put back registrant's iMIS ID
							let billToIdField    = $( '#bill-to-imis-id' ),
							    previousBillToId = billToIdField.data( 'previousValue' );

							billToIdField.val( previousBillToId );
						}
					} );

				$( '#hybrid-fees input:radio' ).focus( function() {
					let feeRadio = $( this );
					//toggle price display on Hybrid
					hybridPaymentMethodPrice( feeRadio );
					promoFieldReset();
				} );

				if ( $( '#hybrid-fee-one' ).length !== 0 && $( '#hybrid-fee-two' ).length !== 0 ) {
					if ( $( '#hybrid-fee-one' ).is( ':checked' ) ) {
						$( '#pay-meth-standard-fee' ).removeClass( 'hidden' );
						$( '#pay-meth-online-fee' ).addClass( 'hidden' );
					} else if ( $( '#hybrid-fee-two' ).is( ':checked' ) ) {
						$( '#pay-meth-online-fee' ).removeClass( 'hidden' );
						$( '#pay-meth-standard-fee' ).addClass( 'hidden' );
					} else {
						$( '#pay-meth-online-fee' ).addClass( 'hidden' );
						$( '#pay-meth-standard-fee' ).addClass( 'hidden' );
					}
				}
			}

			$( '#verify-bill-to-email-btn' )
				.click( function() {
					verifyImisUserViaEmail( 'billing' );
				} );

			$( '#verify-registrant-email-btn' )
				.click( function() {
					verifyImisUserViaEmail( 'registrant' );
				} );

			$( '#verify-referral-email-btn' )
				.click( function() {
					verifyImisUserViaEmail( 'referral' );
				} );

			$( '#btn-restore-address' ).click( function() {
				let regImisId             = $( '#registrant-imis-id' ),
				    previousValue         = regImisId.data( 'previousValue' ),
				    billToImisId          = $( '#bill-to-imis-id' ),
				    previousBillValue     = regImisId.data( 'previousValue' ),
				    referralImisId        = $( '#referral-imis-id' ),
				    previousReferralValue = regImisId.data( 'previousValue' );

				restoreContactDetails( true );
				$( '#verify-registrant-email' ).val( '' );
				regImisId.val( previousValue );
				billToImisId.val( previousBillValue );
				billToImisId.val( previousBillValue );
				//@todo: Do I need to add referral to this?
			} );
		} ); // doc ready

		/**
		 *
		 * @param emailVal
		 * @param imisEventCode
		 *
		 * Function to pass registrant email and imis event code to endpoint, checks if email is registered for passed in event
		 */
		function checkRegistrantEmail( emailVal, imisEventCode, onBehalfOf ) {
			let errorMessage   = 'This user is already registered to this event. Please contact conferences@isda.org if you would like to change or cancel the registration.',
			    emailFormGroup = $( '#registrant_email' )
				    .closest( '.form-group' ),
			    eventForm      = $( '#event-registration-form' );
			$.ajax( {
				        type      : 'GET',
				        url       : wpApiSettings.root + 'isda/v1/check-registrant/?email=' + emailVal + '&event_code=' + imisEventCode + '&on_behalf=' + onBehalfOf,
				        beforeSend: function( xhr ) {
					        xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
				        },
				        success   : function( data ) {
					        if ( data.result === true && data.is_registered === true ) {
						        $( '.help-block-with-errors-check-registrant' )
							        .addClass( 'bg-danger' )
							        .html( errorMessage )
							        .show();
						        $( '.btn-submit-conf-reg' )
							        .addClass( 'disabled prevent-submit' );
						        emailFormGroup.addClass( 'has-error has-danger' );
					        } else {
						        $( '.help-block-with-errors-check-registrant' )
							        .removeClass( 'bg-danger' )
							        .hide();
						        $( '.btn-submit-conf-reg' )
							        .removeClass( 'prevent-submit' );
						        emailFormGroup.removeClass( 'has-error has-danger' );
					        }

					        $( eventForm ).validator( 'update' );
				        },
				        error     : function( data ) {
					        if ( data.result === false ) {
						        $( '.help-block-with-errors-check-registrant' )
							        .hide();
					        }
				        }
			        } );
		}

		function checkEventInImis() {
			var imisEventCode = $( '#event_imis_code' ).val();
			$.ajax( {
				        type      : 'GET',
				        url       : wpApiSettings.root + 'isda/v1/check-event-imis/?event_code=' + imisEventCode,
				        beforeSend: function( xhr ) {
					        xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
				        },
				        success   : function( data ) {
					        if ( data.in_imis === true ) {
						        // Do nothing
					        } else {
						        $( '#event-imis-note div' )
							        .text( data.message );
						        $( '#event-imis-note' )
							        .removeClass( 'hide' );
						        console.log( 'Event not in imis' );
					        }
				        },
				        error     : function( data ) {
					        console.log( 'Error connecting to server' );
				        }
			        } );
		}

		function clearContactDetails() {
			$( '.contact-details .form-control' ).each( function( i, elem ) {
				let field = $( elem );

				if ( field.attr( 'id' ) !== 'registrant_company' ) {
					field.val( '' );
				}
			} );
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Previous button in membership app
		 *
		 * Opens next section by triggering a click on expand/collapse btn
		 * Closes any other open sections
		 */
		function previousCollapsibleBtn() {
			var thisFormStep = $( this ).parents( '.form-step' ),
			    prevFormStep = thisFormStep.prev();

			scrollToFormTop( prevFormStep );
			//if the previous section isn't already open
			if ( prevFormStep.hasClass( 'closed' ) ) {

				//trigger click on previous section's toggle button
				prevFormStep.find( '.btn-section-toggle' ).trigger( 'click' );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Next button in membership app
		 *
		 * Opens next section by triggering a click on expand/collapse btn
		 * Closes any other open sections
		 */
		function nextCollapsibleAppBtn() {
			var thisFormStep = $( this ).parents( '.form-step' ),
			    nextFormStep = thisFormStep.next();

			scrollToFormTop( nextFormStep );
			//if the next section isn't already open
			if ( nextFormStep.hasClass( 'closed' ) ) {
				//trigger click on next section's toggle button
				nextFormStep.find( '.btn-section-toggle' ).trigger( 'click' );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * Scroll to step when prev/next buttons are clicked
		 *
		 * @param selector
		 */
		function scrollToFormTop( formStep ) {
			if ( formStep ) {
				$( 'html, body' ).animate( {
					                           scrollTop: ($( formStep )
						                                       .offset().top - 100
					                           )
				                           }, 500 );
			}
		}

		/**
		 * @todo: Remove as this is in the "global" forms.js file
		 * @summary Add class for section errors
		 *
		 * Checks if the default was prevented due to the validator,
		 * and adds a class to the section containing errors.
		 */
		function revealSectionErrors( e ) {
			var form       = $( this ),
			    errorGroup = form.find( '.form-group.has-error' ),
			    errorStep  = errorGroup.closest( '.form-step' ),
			    formSteps  = form.find( '.form-step' ),
			    errorFee   = form.find( '#fee-type-selection' );

			errorStep.addClass( 'section-has-error' );

			if ( $( '#hybrid-fees' ).hasClass( 'has-error' ) ) {
				errorFee.addClass( 'alert-danger alert' );
			} else {
				errorFee.removeClass( 'alert-danger alert' );
			}

			//check each step for errored groups
			formSteps.each( function() {
				var step = $( this ), groups = step.find( '.form-group' );

				if ( false === groups.hasClass( 'has-error' ) ) {
					step.removeClass( 'section-has-error' );
				}
			} );

		}

		function conditionalRequireCard() {
			var registerCardDetails = $( '#registration-card-details' );

			if ( 'ccard' === $( '#payment-type' ).val() ) {
				requireCard( registerCardDetails );
			} else {
				hideCard( registerCardDetails );
			}
		}

		//address fields and info pulled from iMIS are always read only
		function setReadonlyFields() {
			let onBehalfOfCheckbox = $( '#event-registration-form input[name=_register_myself]:checked' )
				.val();

			let fields = [
				'registrant_fname', 'registrant_lname', 'registrant_email',
				'registrant_address', 'registrant_address2', 'registrant_city',
				'registrant_zip', 'registrant_state', 'registrant_country', 
				'registrant_company', 'registrant_phone'
			];

			$.each( fields, ( index, fieldId ) => {
				$( `#${ fieldId }` ).prop( 'readonly', true );
			} );

			// TODO: Removing this for the time being, but may need to add it back in. Remove if definitely no longer needed.
			// if ( onBehalfOfCheckbox === 'someone_else' ) {
			// 	$( '#registrant_fname' ).prop( 'readonly', false );
			// 	$( '#registrant_lname' ).prop( 'readonly', false );
			// }
		}

		/**
		 * Email verification field in contact details, only require on "someone else"
		 * Email verification field (referral) in payment method, only require on "yes"
		 */
		function toggleRequiredOnVerifyEmail( checkbox ) {
			let verifyContactDetailsReg = $( '#verify-registrant-email' ),
			    verifyReferralsEmail    = $( '#referral-email' );

			//for verifying someone else email
			if ( checkbox.checked && 'someone_else' === checkbox.value ) {
				verifyContactDetailsReg.prop( 'required', true );
			} else {
				verifyContactDetailsReg.prop( 'required', false );
			}

			//for verifying referral email
			if ( checkbox.checked && 'yes' === checkbox.value ) {
				verifyReferralsEmail.prop( 'required', true );
			} else {
				verifyReferralsEmail.prop( 'required', false );
				$( '.btn-submit-conf-reg' )
					.removeClass( 'disabled prevent-submit' )
					.removeAttr( 'disabled' );
				eventRegistrationForm.validator( 'update' );
			}
		}

		/*
		 Toggle required on billing email field
		 */
		function toggleRequiredOnVerifyBillingEmail( billingCheckbox ) {
			let verifyBillingEmailField = $( '#bill-to-email' );

			if ( billingCheckbox.is( ':checked' ) ) {
				verifyBillingEmailField.prop( 'required', true );
			} else {
				verifyBillingEmailField.prop( 'required', false );
			}
		}

		function requireCard( ccDetails ) {
			ccDetails.find( '.form-control.ccard' )
			         .attr( 'required', 'required' );
			ccDetails.show();
		}

		function hideCard( ccDetails ) {
			ccDetails.find( '.form-control.ccard' ).prop( 'required', false )
			         .removeAttr( 'required', 'required' );
			ccDetails.hide();
		}

		function saveInitialDetails() {
			//contact details
			$( '.contact-details .form-control' ).each( function( i, elem ) {
				let previousValue = $( elem ).val();
				$( elem ).data( 'previousValue', previousValue );
			} );

			//hidden iMIS ID fields
			let regImisIdField  = $( '#registrant-imis-id' ),
			    prevImisId      = regImisIdField.val(),
			    billImisIdField = $( '#bill-to-imis-id' ),
			    prevBillImisId  = billImisIdField.val();

			regImisIdField.data( 'previousValue', prevImisId );
			billImisIdField.data( 'previousValue', prevBillImisId );

			//billing address
			$( '#event-billing-address .form-control' )
				.each( function( i, elem ) {
					let previousValue = $( elem ).val();
					$( elem ).data( 'previousValue', previousValue );
				} );
		}

		function restoreContactDetails( cleariMISDetails = false ) {
			let currentVal                      = $( '#event-registration-form input[name=_register_myself]:checked' )
				    .val(), confirmEmailSection = $( '.event-registrant-email' ),
			    regiMISId                       = $( '#registrant-imis-id' ),
			    previousRegiMISId               = regiMISId.data( 'previousValue' );

			if ( 'myself' === currentVal ) {
				//puts back registrant address
				$( '.contact-details .form-control' )
					.each( function( i, elem ) {
						let previousValue = $( elem ).data( 'previousValue' );
						$( elem ).val( previousValue );
					} );

				//put back original iMIS ID from initial load
				regiMISId.val( previousRegiMISId );

				confirmEmailSection.addClass( 'hidden' );
			} else if ( cleariMISDetails === true ) {
				//clears fields completely
				$( '.contact-details .form-control' )
					.each( function( i, elem ) {
						$( elem ).val( '' );
					} );
				//clear response styles and hide
				$( '#verify-registrant-response-message' ).addClass( 'hidden' )
				                                          .removeClass( 'alert-success' )
				                                          .removeClass( 'alert-danger' );
			} else if ( 'someone_else' === currentVal ) {
				confirmEmailSection.removeClass( 'hidden' );
			}
		}

		function agmPlusFeeConditional( radio ) {
			//if "Plus Fee" is selected, make following text field required
			let agmConditional = $( '#agm-fee-conditional' ),
			    otherField     = agmConditional.find( 'input:text' );

			if ( radio.val() === 'mr_main2' ) {
				//remove disabled from text field
				agmConditional.removeClass( 'hidden' );
				//add required from text field
				otherField.attr( 'required', 'required' );
			} else {
				//remove required from text field
				otherField.removeAttr( 'required', 'required' );
				otherField.val( '' );
				//disable text field
				agmConditional.addClass( 'hidden' );
			}

			$( '#event-registration-form' ).validator( 'update' );
		}

		//@todo: Why don't we set regiType by checking the .onBehalf value directly?
		let regiType = '', feeType = 'MR_MAIN';

		function agmPaymentMethodPrice( radio ) {
			//if "Plus Fee" is selected, show that fee in payment method instead of standard
			let standardFee = $( '#pay-meth-standard-fee' ),
			    plusFee     = $( '#pay-meth-plus-fee' );

			if ( radio.val() === 'mr_main2' ) {
				plusFee.removeClass( 'hidden' );
				standardFee.addClass( 'hidden' );
				feeType = 'MR_MAIN2';
			} else {
				plusFee.addClass( 'hidden' );
				standardFee.removeClass( 'hidden' );
				feeType = 'MR_MAIN';
			}
		}

		function hybridPaymentMethodPrice( radio ) {
			//if "online Fee" is selected, show that fee in payment method
			let standardFee = $( '#pay-meth-standard-fee' ),
			    plusFee     = $( '#pay-meth-online-fee' );

			if ( radio.val() === 'mr_hybrid' ) {
				plusFee.removeClass( 'hidden' );
				standardFee.addClass( 'hidden' );
				regiType = 'online';
				feeType = 'MR_HYBRID';
			} else {
				plusFee.addClass( 'hidden' );
				standardFee.removeClass( 'hidden' );
				regiType = 'inperson';
				feeType = 'MR_MAIN';
			}

		}

		let enterPromoCodeBlock       = $( '#enter-promo-code-block' ),
		    applyPromoCodeButton      = $( '#apply-promo-code' ),
		    promoCodeField            = $( '#promo-code-field' ),
		    helpBlockPromoCodeField   = $( '.help-block-promo-code-field' ),
		    paymentMethStandardFee    = $( '#pay-meth-standard-fee' ),
		    paymentMethOnlineFee      = $( '#pay-meth-online-fee' ),
		    paymentMethPlusFee        = $( '#pay-meth-plus-fee' ),
		    wasPromoButtonClicked     = $( '#was-promo-button-clicked' ),
		    promoCodeBlock            = $( '#promo-code-block' ),
		    btnSubmitConfReg          = $( '.btn-submit-conf-reg' ),
		    promoCodePrice            = $( '.promo-code-price' ),
		    earlyBirdPaymentSection   = $( '.early-bird-pricing-inline-text-payment-section' ),
		    removePromoCode           = $( '#remove-promo-code' ),
		    eventRegistrationForm     = $( '#event-registration-form' ),
		    referralCheckbox          = $( '#referral-confirmation' ),
		    referralSectionWrap       = $( '#referral-email-wrap' ),
		    referralEmailField        = $( '#referral-email' ),
		    verifyReferralMsg         = $( '#verify-referral-response-message' ),
		    cancelReferralBtn         = $( '#cancel-referral-email-btn' ),
		    referralConfirmBtnClicked = false;

		// call function to initiate AJAX call
		applyPromoCodeButton.click( checkPromoCodeAjax );

		// show and hide the promo code field on check
		enterPromoCodeBlock.hide();

		$( '#enter-promo-code-link' ).change( function( e ) {
			enterPromoCodeBlock.toggle( $( this ).is( ':checked' ) );

			if ( $( this )
				     .is( ':checked' ) && referralCheckbox.is( ':checked' ) ) {
				referralCheckbox.prop( 'checked', false );
				referralSectionWrap.addClass( 'hidden' );
				referralFieldReset();
				verifyReferralMsg.addClass( 'hidden' );
			}
		} );

		cancelReferralBtn.click( function() {
			referralFieldReset();
			verifyReferralMsg.addClass( 'hidden' );
			reminderToFillReferral();
		} );

		//show and hide referral email confirmation on check
		referralCheckbox.change( function( e ) {
			let promoCodeCheckbox = $( '#enter-promo-code-link' );
			$( '#referral-email-wrap' ).toggleClass( 'hidden' );

			toggleRequiredOnVerifyEmail( e.currentTarget );

			if ( promoCodeCheckbox.is( ':checked' ) ) {
				promoCodeCheckbox.prop( 'checked', false );
				enterPromoCodeBlock.hide();
				promoFieldReset();
			}
		} );

		//verify referral email on button click
		$( '#verify-referral-email-btn' ).click( function() {
			verifyImisUserViaEmail( 'referral' );
		} );

		// check user-entered promo code against required code.
		// Receives:
		// hardship fee, default fee, is early bird active, early bird end date,
		// difference between default fee and hardship fee,
		// whether the entered code matches required code.
		// Returns user-entered code, and true that apply button was clicked
		let errorMessageClearForm = 'To clear this field please click the \'Cancel\' button';

		function checkPromoCodeAjax() {
			enteredPromoCodeField = $( '#promo-code-field' ).val(),
			//we use the checkbox as extra confirmation otherwise the code marks the fee type as group even when it isn't (e.g. referral)
			promoCodeFieldChecked = $('#enter-promo-code-link').is(':checked'),
			wasPromoButtonClicked.val( true );

			$.ajax( {
				        type       : 'POST',
				        url        : applyPromoCode.ajaxurl,
				        cache      : false,
				        dataType   : 'json',
				        crossDomain: true, // enable ssl/nonssl
				        data       : {
					        action               : 'apply_promo_code_request',
					        enteredPromoCode     : enteredPromoCodeField, // data to be sent
					        wasApplyButtonClicked: true,
					        registrationType     : regiType,
					        registrationFeeType  : feeType
				        },
				        success    : function( response ) {
					        let isEarlyBirdActive = response.early_bird_active;

					        // if promo code is valid
					        if ( response.hardship_promo_matches || (response.group_nm_promo_matches && promoCodeFieldChecked ) || response.exclusive_nm_promo_matches || response.referral_nm_promo_matches || (response.group_m_promo_matches && response.is_member_code_valid && promoCodeFieldChecked ) || (response.exclusive_m_promo_matches && response.is_exclusive_member_code_valid
					             ) || (response.referral_m_promo_matches && response.is_referral_member_code_valid
					             ) ) {
						        paymentMethStandardFee
							        .addClass( 'strikethrough-registration-price' );
						        paymentMethOnlineFee
							        .addClass( 'strikethrough-registration-price' );
						        paymentMethPlusFee
							        .addClass( 'strikethrough-registration-price' );
						        enterPromoCodeBlock
							        .removeClass( 'has-error' );
						        helpBlockPromoCodeField
							        .html( response.promo_type + ' promo code applied' );
						        promoCodePrice
							        .html( '<p>US$' + response.price_w_promo + ' (' + response.promo_type + ')</p>' )
							        .addClass( 'final-promo-price-payment-section' );
					        } else if ( (response.group_m_promo_matches && response.is_member_code_valid !== true
					                    ) || (response.exclusive_m_promo_matches && response.is_exclusive_member_code_valid !== true
					                    ) ) { //if non-member enters group/super early member code
						        promoCodeField
							        .addClass( 'has-error' );
						        enterPromoCodeBlock
							        .addClass( 'has-error' );
						        helpBlockPromoCodeField
							        .html( 'This code is valid for ISDA Members only' + '<br/>' + errorMessageClearForm );
					        } else {
						        // if promo code is invalid
						        paymentMethStandardFee
							        .removeClass( 'strikethrough-registration-price' );
						        paymentMethOnlineFee
							        .removeClass( 'strikethrough-registration-price' );
						        paymentMethPlusFee
							        .removeClass( 'strikethrough-registration-price' );
						        enterPromoCodeBlock
							        .addClass( 'has-error' );
						        helpBlockPromoCodeField
							        .html( 'Invalid Code' + '<br/>' + errorMessageClearForm );
						        earlyBirdPaymentSection
							        .html( isEarlyBirdActive
							               ? 'Early bird price until ' + response.early_bird_ends
							               : '' )
							        .removeClass( 'final-promo-price-payment-section' );
					        }

					        eventRegistrationForm.validator( 'update' );

					        // when emptying promo code field when it is empty
					        if ( enteredPromoCodeField === '' ) {
						        helpBlockPromoCodeField
							        .html( 'Please provide a promo code' + '<br/>' + errorMessageClearForm );
						        wasPromoButtonClicked.val( '' );
						        eventRegistrationForm
							        .validator( 'update' );
					        }

					        // when emptying promo code field when it is populated
					        removePromoCode.click( function() {
						        promoFieldReset();
						        if ( enteredPromoCodeField === '' ) {
							        helpBlockPromoCodeField
								        .html( '' );
						        }
						        earlyBirdPaymentSection
							        .html( isEarlyBirdActive
							               ? 'Early bird price until ' + response.early_bird_ends
							               : '' )
							        .removeClass( 'final-promo-price-payment-section' );
					        } );
				        }
			        } );

		}

		let timeout;

		function ifApplyNotClicked() {
			enterPromoCodeBlock.addClass( 'has-error has-danger' );
			helpBlockPromoCodeField
				.html( 'Please click \'Apply\' to activate your code' + '<br/>' + errorMessageClearForm );
		}

		function promoFieldReset() {
			promoCodeBlock
				.removeClass( 'has-error has-danger' );
			wasPromoButtonClicked
				.val( '' );
			helpBlockPromoCodeField
				.html( '' );
			promoCodeField.val( '' );
			promoCodePrice.html( '' );
			paymentMethStandardFee
				.removeClass( 'strikethrough-registration-price' );
			paymentMethOnlineFee
				.removeClass( 'strikethrough-registration-price' );
			enterPromoCodeBlock
				.removeClass( 'has-error' );
			referralConfirmBtnClicked = false;
			eventRegistrationForm
				.validator( 'update' );
		}

		promoCodeField.on( 'blur', function() {
			if ( $( this ).val() !== '' && wasPromoButtonClicked
				.val() === '' ) {
				timeout = setTimeout( ifApplyNotClicked, 2000 );
				btnSubmitConfReg
					.addClass( 'disabled prevent-submit' )
					.attr( 'disabled', 'disabled' );
				promoCodeField.attr( 'required', 'required' );
			} else {
				helpBlockPromoCodeField
					.html( errorMessageClearForm ).removeClass( 'with-errors' );
				enterPromoCodeBlock
					.removeClass( 'has-error has-danger' );
				promoCodeField.removeAttr( 'required' );
				promoCodeBlock.removeClass( 'has-error has-danger' );
				btnSubmitConfReg
					.removeClass( 'disabled prevent-submit' )
					.removeAttr( 'disabled' );
			}
			eventRegistrationForm.validator( 'update' );
		} );

		applyPromoCodeButton.on( 'click', function() {
			promoCodeBlock.removeClass( 'has-error has-danger' );
			clearTimeout( timeout );
			promoCodeField.removeAttr( 'required' );
			btnSubmitConfReg
				.removeClass( 'disabled prevent-submit' )
				.removeAttr( 'disabled' );
			eventRegistrationForm.validator( 'update' );
		} );

		btnSubmitConfReg.on( 'click', function( e ) {
			if ( $( this ).hasClass( 'prevent-submit' ) ) {
				e.preventDefault();
			}
		} );

		removePromoCode.click( function() {
			btnSubmitConfReg
				.removeClass( 'disabled prevent-submit' )
				.removeAttr( 'disabled' );
			promoCodeBlock.removeClass( 'has-error has-danger' );
			helpBlockPromoCodeField
				.html( '' );
			promoCodeField.removeAttr( 'required' );
			eventRegistrationForm.validator( 'update' );

		} );

		function verifyImisUserViaEmail( verifyType ) {
			let emailAddressToCheck                   = '', eventPostId = '',
			    verifyRegistrantSpinner               = $( '#verify-registrant-spinner' ),
			    verifyBillToSpinner                   = $( '#verify-bill-to-spinner' ),
			    verifyReferralSpinner                 = $( '#referral-validation-spinner' );

			//set to true
			referralConfirmBtnClicked = true;

			if ( verifyType === 'registrant' ) {
				emailAddressToCheck = $( '#verify-registrant-email' ).val();
				verifyRegistrantSpinner.removeClass( 'hidden' );
			} else if ( verifyType === 'referral' ) {
				emailAddressToCheck = referralEmailField.val();
				eventPostId = referralEmailField.attr( 'data-event-post-id' );
				verifyReferralSpinner.removeClass( 'hidden' );
			} else {
				emailAddressToCheck = $( '#bill-to-email' ).val();
				verifyBillToSpinner.removeClass( 'hidden' );
			}

			$.ajax( {
				        type      : 'GET',
				        url       : wpApiSettings.root + 'isda/v1/event-registration-verify-imis',
				        data      : {
					        verify_type   : verifyType,
					        email_to_check: emailAddressToCheck,
					        event_post_id : eventPostId,
					        reg_type      : regiType,
					        fee_type      : feeType
				        },
				        beforeSend: function( xhr ) {
					        xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
				        },
				        success   : function( response ) {
					        let referralInfo = response[ 0 ];

					        toggleVerificationClasses( referralInfo );

					        if ( referralInfo.verify_type === 'referral' && referralInfo.final_prices.price_wo_promo && referralInfo.verification_complete ) {
						        let referralPrice           = referralInfo.final_prices.price_wo_promo,
						            registrantUserTypeField = $( 'input[name=_registrant_user_type]' );

						        verifyReferralSpinner.addClass( 'hidden' );
						        $( '#referral-imis-id' )
							        .val( referralInfo.user_imis_id );

						        if ( registrantUserTypeField.val() === 'regular' ) {
							        if ( referralInfo.is_member ) {
								        registrantUserTypeField.val( 'referral-m' );
							        } else {
								        registrantUserTypeField.val( 'referral-nm' );
							        }
						        }

						        paymentMethStandardFee.addClass( 'strikethrough-registration-price' );
						        paymentMethOnlineFee.addClass( 'strikethrough-registration-price' );
						        paymentMethPlusFee.addClass( 'strikethrough-registration-price' );
						        enterPromoCodeBlock.removeClass( 'has-error' );
						        promoCodePrice.html( '<p>US$' + referralPrice + ' ( Referral Discount )</p>' )
						                      .addClass( 'final-promo-price-payment-section' );
					        } else if ( referralInfo.verify_type === 'registrant' ) {
						        verifyRegistrantSpinner.addClass( 'hidden' );
					        } else {
						        verifyBillToSpinner.addClass( 'hidden' );
					        }
				        },
				        error     : function( response ) {
					        console.log( 'Something went wrong... Check tokens.', response );
				        }
			        } );
		}

		function referralFieldReset() {
			referralConfirmBtnClicked = false;

			referralSectionWrap.removeClass( 'has-error has-danger' );
			referralEmailField.val( '' );
			$( 'input[name=_registrant_user_type]' ).val( 'regular' );
			$( 'input[name=_referral_imis_id]' ).val( '' );
			helpBlockPromoCodeField.html( '' );
			promoCodeField.val( '' );
			promoCodePrice.html( '' );
//			verifyReferralMsg.addClass( 'hidden' );
			paymentMethStandardFee
				.removeClass( 'strikethrough-registration-price' );
			paymentMethOnlineFee
				.removeClass( 'strikethrough-registration-price' );
			btnSubmitConfReg.removeClass( 'disabled prevent-submit' )
			                .removeAttr( 'disabled' );

			eventRegistrationForm
				.validator( 'update' );
		}

		referralEmailField.on( 'blur', function() {
			reminderToFillReferral();
		} );

		function reminderToFillReferral( ) {
			//If there is already a message being displayed, don't fire.
			if ( referralEmailField.val() !== '' && !referralConfirmBtnClicked && !verifyReferralMsg.is(':visible') && verifyReferralMsg.text().length === 0 ) {
				timeout = setTimeout( function() {
					referralSectionWrap.addClass( 'has-error has-danger' );
					verifyReferralMsg.addClass( 'alert-danger' )
					                 .html( 'Please confirm referral email before proceeding with form submission.' )
					                 .removeClass( 'hidden' );
				}, 2000 );
				btnSubmitConfReg
					.addClass( 'disabled prevent-submit' )
					.attr( 'disabled', 'disabled' );
			}
		}

		function toggleVerificationClasses( response ) {
			let verifyType         = response[ 'verify_type' ],
			    regMessageDiv      = $( '#verify-registrant-response-message' ),
			    billToMessageDiv   = $( '#verify-bill-to-response-message' ),
			    referralMessageDiv = $( '#verify-referral-response-message' ),
			    verifyStatus       = response[ 'verification_complete' ],
			    message            = response[ 'verification_msg' ];

			if ( verifyType === 'registrant' ) {
				if ( verifyStatus ) {
					regMessageDiv.removeClass( 'alert-danger' )
					             .addClass( 'alert-success' );
				} else {
					regMessageDiv.removeClass( 'alert-success' )
					             .addClass( 'alert-danger' );
				}

				regMessageDiv.text( message ).removeClass( 'hidden' );
			} else if ( verifyType === 'referral' ) {
				if ( verifyStatus ) {
					referralMessageDiv.removeClass( 'alert-danger' )
					                  .addClass( 'alert-success' );
					referralSectionWrap.removeClass( 'has-error' ).removeClass( 'has-danger' );

					//enable form submit
					btnSubmitConfReg.removeClass( 'disabled prevent-submit' )
					                .removeAttr( 'disabled' );
				} else {
					referralMessageDiv.removeClass( 'alert-success' )
					                  .addClass( 'alert-danger' );
					//enable form submit
					btnSubmitConfReg.addClass( 'disabled prevent-submit' );
				}

				$( '#referral-validation-spinner' ).addClass( 'hidden' );
				referralMessageDiv.text( message ).removeClass( 'hidden' );
				eventRegistrationForm.validator( 'update' );

			} else if ( verifyType === 'billing' ) {
				if ( verifyStatus ) {
					billToMessageDiv.removeClass( 'alert-danger' )
					                .addClass( 'alert-success' );
				} else {
					billToMessageDiv.removeClass( 'alert-success' )
					                .addClass( 'alert-danger' );
				}

				billToMessageDiv.text( message ).removeClass( 'hidden' );
			} else {
				//hide/empty both response message divs
				regMessageDiv.text( '' );
				billToMessageDiv.text( '' );
				regMessageDiv.addClass( 'hidden' );
				billToMessageDiv.addClass( 'hidden' );
			}

			//only pull addresses on success, no need for referrals
			if ( verifyStatus && verifyType !== 'referral' ) {
				pullAddressFieldsFromImis( response );
			}
		}

		function pullAddressFieldsFromImis( response ) {
			let emailAddress = response[ 'email_to_check' ],
			    firstName    = response[ 'user_first_name' ],
			    lastName     = response[ 'user_last_name' ],
			    company      = response[ 'user_company' ],
			    title        = response[ 'user_title' ],
			    phone        = response[ 'user_phone' ],
			    wholeAddress = response[ 'user_address_fields' ],
			    address1     = wholeAddress[ 'get_address_1' ],
			    address2     = wholeAddress[ 'get_address_2' ],
			    city         = wholeAddress[ 'get_address_city' ],
			    country      = wholeAddress[ 'get_address_country' ],
			    state        = wholeAddress[ 'get_address_state' ],
			    zip          = wholeAddress[ 'get_address_zip' ],
			    verifyType   = response[ 'verify_type' ],
			    userImisID   = response[ 'user_imis_id' ];

			//do not continue if verification is false
			if ( !response[ 'verification_complete' ] ) {
				return;
			}

			if ( verifyType === 'registrant' ) {
				$( '#registrant_fname' ).val( firstName );
				$( '#registrant_lname' ).val( lastName );
				//trigger blur so we can check if person is already registered
				$( '#registrant_email' ).val( emailAddress ).blur();
				$( '#registrant_address' ).val( address1 );
				$( '#registrant_address2' ).val( address2 );
				$( '#registrant_city' ).val( city );
				$( '#registrant_zip' ).val( zip );
				$( '#registrant_country' ).val( country );
				$( '#registrant_state' ).val( state );
				$( '#registrant_company' ).val( company );
				$( '#registrant_title' ).val( title );
				$( '#registrant_phone' ).val( phone );

				//add iMIS code into hidden field
				$( '#registrant-imis-id' ).val( userImisID );
			} else if ( verifyType === 'billing' ) {
				$( '#checkout-billing-address' ).val( address1 );
				$( '#checkout-billing-address-two' ).val( address2 );
				$( '#checkout-billing-city' ).val( city );
				$( '#checkout-billing-postal-code' ).val( zip );
				$( '#checkout-billing-country' ).val( country );
				$( '#checkout-billing-state' ).val( state );

				//add iMIS code into hidden field
				$( '#bill-to-imis-id' ).val( userImisID );
			}
		}
	}
)( jQuery );